export default {
  name: 'custom-tracking',

  componentDidMount () {
    if (this.el.dataset.type === 'jobs') {
      this.el.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', (e) => {
          // eslint-disable-next-line no-undef
          _paq.push(['trackEvent', 'Click', 'Offre d\'emploi', `${e.target.textContent}`])
        })
      })
    }
  },
}
